module.exports = __webpack_public_path__ + "img/temp.4e75f24c.jpg";